<template>
  <div style="margin: 10px 40px 10px 30px">
    <el-form :model="voiceForm" :rules="voiceRules" ref="voiceForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="标题" prop="title">
        <el-input placeholder="请输入标题" v-model="voiceForm.title"></el-input>
      </el-form-item>
      <el-form-item label="通知内容" prop="text">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入通知内容"
          v-model="voiceForm.text"></el-input>
      </el-form-item>
      <el-form-item v-if="device.push_type === 1" label="组织单位" prop="oid">
        <el-cascader v-fixZoom
          filterable
          :disabled="isDisabled"
          style="width: 100%"
          v-model="voiceForm.oid"
          :options="treeData"
          placeholder="请选择组织"
          :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
          ref="alarmType"
          :show-all-levels="true"
          @change="changeOrg"></el-cascader>
      </el-form-item>
    </el-form>
    <div v-if="device.push_type === 1" style="height: 1px;background-color: #cccccc"></div>
    <div style="margin-top: 10px" v-if="device.push_type === 1">
      <div style="height: 30px">
        <span>查询设备数量： <strong style="color: #1a1a1a">{{deviceCnt}}&nbsp;台设备</strong></span>
      </div>
      <div>
        <el-row style="height: 30px">
          <el-col :span="3" style="text-align: right">
            <span>性别：</span>
          </el-col>
          <el-col :span="21">
            <el-checkbox-group v-model="person_sex" @change="changeSex">
              <el-checkbox label="男" name="type"></el-checkbox>
              <el-checkbox label="女" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row style="height: 30px">
          <el-col :span="3" style="text-align: right;">
            <span>年龄：</span>
          </el-col>
          <el-col :span="21">
            <el-radio-group v-model="person_birthday" @change="changeBirthday">
              <el-radio :label="2">>60岁</el-radio>
              <el-radio :label="3">>70岁</el-radio>
              <el-radio :label="0">60岁~70岁</el-radio>
              <el-radio :label="1">70岁~80岁</el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <div v-if="showOther" style="text-align: center">
          <el-input size="small" style="width: 50px;" v-model="leftNum" @blur="blurLeft"></el-input>
          <span>~</span>
          <el-input size="small" style="width: 50px;" v-model="rightNum" @blur="blurRight"></el-input>
          <div style="height: 30px;line-height: 30px">{{textHit}}</div>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px">
      <el-row style="margin: 0 30px">
        <el-col :span="12">
          <div class="cancel-btn" @click="close()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submit('voiceForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {addvoicemsg, queryorgdevicecount} from '../../../api/device'

export default {
  name: 'voiceOpenShow',
  model: {
    prop: 'voiceShow',
    event: 'change'
  },
  props: {
    device: {
      type: Object
    }
  },
  data () {
    return {
      isDisabled: false,
      ageRange: [
        {
          toDate: new Date(new Date().getTime() - (60 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd'),
          fromDate: new Date(new Date().getTime() - (70 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
        },
        {
          toDate: new Date(new Date().getTime() - (70 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd'),
          fromDate: new Date(new Date().getTime() - (80 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
        },
        {
          toDate: new Date(new Date().getTime() - (60 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd'),
          fromDate: '19000101'
        },
        {
          toDate: new Date(new Date().getTime() - (70 * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd'),
          fromDate: '19000101'
        }
      ],
      voiceForm: {
        imei: '',
        title: '',
        text: '',
        push_type: 2, // 1 组织批量 2 指定设备 3 小区批量 4家庭批量 5选择人群
        push_mqtttopic: '',
        oid: 0, // push_type =1 要有值
        did: 0, // push_type =2 要有值
        cid: 0, // push_type =3 要有值
        hid: 0, // push_type =4 要有值
        device_type: 700 // 设备类型，必填，默认700
      },
      voiceRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        text: [
          { required: true, message: '请输入通知内容', trigger: 'blur' }
        ],
        oid: [
          { required: true, message: '请选择组织单位', trigger: 'change' }
        ]
      },
      orgData: [],
      treeData: [],
      deviceCnt: 0,
      person_sex: [], // 性别
      person_birthday1: [],
      person_birthday: '', // 年龄范围
      showOther: false,
      leftNum: '',
      rightNum: '',
      textHit: '自定义年龄。',
      sendOrgObj: '',
      sendPersonSex: [],
      sendPersonBirthday: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    // 1、didVoiceDetails.vue 设备详情 2、voiceNotification.vue语音通知 3、community.vue小区管理(暂弃) 4、批量语音通知
    // console.log(this.device)
    this.voiceForm.push_type = this.device.push_type
    if (this.device.push_type === 2) {
      this.voiceForm.imei = this.device.device.deviceid
      this.voiceForm.did = this.device.device.id
      this.voiceForm.push_mqtttopic = this.device.push_mqtttopic
    }
    if (this.device.push_type === 1) {
      this.voiceForm.oid = ''
      if (this.device.isOrgVoice) {
        console.log(this.device)
        this.voiceForm.oid = this.device.orgObj.id
        this.isDisabled = true

        this.voiceForm.push_mqtttopic = this.device.orgObj.mqttlevel
        this.sendOrgObj = this.device.orgObj
        this.queryOrg()
      }
    }
    this.getOrgData()
  },
  mounted () {
  },
  methods: {
    // 组织
    getOrgData () {
      this.orgData = this.device.org
      // 所属组织
      let lastLevel = 100
      const arr = this.device.org
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.treeData.push(arr[i])
        }
      }
      for (let i = 0; i < this.treeData.length; i++) {
        const child = this.arrayToNode(arr, this.treeData[i].id)
        if (child.length !== 0) {
          this.treeData[i].child = child
        }
      }
      // console.log(this.treeData)
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    close () {
      this.$emit('change', false)
    },
    changeOrg (id) {
      let obj = ''
      for (let i = 0; i < this.device.org.length; i++) {
        if (id === this.device.org[i].id) {
          this.voiceForm.push_mqtttopic = this.device.org[i].mqttlevel
          obj = this.device.org[i]
          this.sendOrgObj = obj
          this.queryOrg()
        }
      }
    },
    queryOrg () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      let day = new Date().format('yyyyMMdd')
      let obj = this.sendOrgObj
      let data = {
        mqtttopic: obj.mqttlevel,
        device_type: 700,
        oid: obj.id,
        person_expand: 0, // 扩展功能  int 0不开启；1开启
        person_sex: this.sendPersonSex, // 未选择填入[0,1]
        person_birthday_from: '', // 未选择填入 19000101
        person_birthday_to: '' // 未选择填入当天日期
      }
      if (this.sendPersonSex.length !== 0 || this.sendPersonBirthday !== '') {
        data.person_expand = 1
      }
      if (this.sendPersonBirthday !== '') {
        data.person_birthday_from = this.sendPersonBirthday.fromDate
        data.person_birthday_to = this.sendPersonBirthday.toDate
      }
      if (data.person_expand === 1) {
        if (data.person_sex.length === 0) {
          data.person_sex = [0, 1]
        }
        if (data.person_birthday_from === '') {
          data.person_birthday_from = '19000101'
        }
        if (data.person_birthday_to === '') {
          data.person_birthday_to = day
        }
      }
      queryorgdevicecount(data).then(res => {
        this.deviceCnt = res.data.devicecnt
      }).catch(() => {})
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            imei: this.voiceForm.imei,
            title: this.voiceForm.title,
            text: this.voiceForm.text,
            push_type: this.voiceForm.push_type, // 1 组织批量 2 指定设备 3 小区批量 4家庭批量 5指定条件(按人群)
            push_mqtttopic: this.voiceForm.push_mqtttopic,
            oid: parseInt(this.voiceForm.oid), // push_type =1 要有值
            did: parseInt(this.voiceForm.did), // push_type =2 要有值
            cid: parseInt(this.voiceForm.cid), // push_type =3 要有值
            hid: parseInt(this.voiceForm.hid), // push_type =4 要有值
            device_type: this.voiceForm.device_type, // 设备类型，必填，默认700
            person_expand: 0, // 扩展功能  int 0不开启；1开启
            person_sex: this.sendPersonSex,
            person_birthday_from: '',
            person_birthday_to: ''
          }
          if (this.sendPersonSex.length !== 0 || this.sendPersonBirthday !== '') {
            data.push_type = 5
            data.person_expand = 1
          }
          if (this.sendPersonBirthday !== '') {
            data.person_birthday_from = this.sendPersonBirthday.fromDate
            data.person_birthday_to = this.sendPersonBirthday.toDate
          }
          if (data.person_expand === 1) { // 开启扩展功能 两者必填
            if (this.sendPersonBirthday === '') {
              // eslint-disable-next-line no-extend-native
              Date.prototype.format = this.validate.format
              let day = new Date().format('yyyyMMdd')
              data.person_birthday_from = '19000101'
              data.person_birthday_to = day
            }
            if (this.sendPersonSex.length === 0) {
              data.person_sex = [0, 1]
            }
          }
          // console.log(data)
          addvoicemsg(data).then(res => {
            this.$notify({
              title: '成功',
              message: '成功添加语音通知',
              type: 'success',
              duration: 2000
            })
            this.$emit('getFatherVoice')
            this.$emit('change', false)
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changeSex () {
      console.log(this.person_sex)
      this.sendPersonSex = []
      if (this.person_sex.length === 0) {
        this.sendPersonSex = []
      } else if (this.person_sex.length === 1) {
        if (this.person_sex[0] === '男') {
          this.sendPersonSex = [1]
        } else if (this.person_sex[0] === '女') {
          this.sendPersonSex = [0]
        }
      } else {
        this.sendPersonSex = [0, 1]
      }
      // console.log(this.sendPersonSex)
      if (this.voiceForm.oid !== '') {
        this.queryOrg()
      }
    },
    changeBirthday () {
      // console.log(this.ageRange[this.person_birthday])
      this.sendPersonBirthday = ''
      if (this.person_birthday === '其他') {
        this.queryOrg()
        this.showOther = true
      } else {
        this.showOther = false
        this.sendPersonBirthday = this.ageRange[this.person_birthday]
      }
      if (this.sendPersonBirthday !== '') {
        if (this.voiceForm.oid !== '') {
          this.queryOrg()
        }
      }
    },
    blurLeft () {
      if (this.rightNum !== '') {
        if (this.leftNum >= this.rightNum) {
          this.leftNum = ''
          return
        }
      }
      let toDate = new Date(new Date().getTime() - (this.leftNum * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
      if (this.leftNum !== '' && this.rightNum !== '') {
        this.textHit = this.leftNum + '岁' + '~' + this.rightNum + '岁'
        let fromDate = new Date(new Date().getTime() - (this.rightNum * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
        this.sendPersonBirthday = {
          fromDate: fromDate,
          toDate: toDate
        }
      } else if (this.leftNum !== '') {
        this.textHit = '>' + this.leftNum + '岁'
        this.sendPersonBirthday = {
          fromDate: '19000101',
          toDate: toDate
        }
      } else {
        this.sendPersonBirthday = ''
        this.textHit = '自定义年龄。'
      }
      if (this.sendPersonBirthday !== '') {
        if (this.voiceForm.oid !== '') {
          this.queryOrg()
        }
      }
    },
    blurRight () {
      if (this.leftNum !== '') {
        if (this.rightNum <= this.leftNum) {
          this.rightNum = ''
          return
        }
      }
      let fromDate = new Date(new Date().getTime() - (this.rightNum * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
      if (this.leftNum !== '' && this.rightNum !== '') {
        this.textHit = this.leftNum + '岁' + '~' + this.rightNum + '岁'
        let toDate = new Date(new Date().getTime() - (this.leftNum * 365 * 24 * 60 * 60 * 1000)).format('yyyyMMdd')
        this.sendPersonBirthday = {
          fromDate: fromDate,
          toDate: toDate
        }
      } else if (this.rightNum !== '') {
        this.textHit = '>' + this.rightNum + '岁'
        this.sendPersonBirthday = {
          fromDate: fromDate,
          toDate: '19000101'
        }
      } else {
        this.sendPersonBirthday = ''
        this.textHit = '自定义年龄。'
      }
      if (this.sendPersonBirthday !== '') {
        if (this.voiceForm.oid !== '') {
          this.queryOrg()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/voiceOpenShow.vue